import { MapPin, Phone, MessageCircle, Clock } from "lucide-react";
import { SITE } from "../data/menu";
import { Flourish, PetalField } from "../components/decor";
import { Reveal } from "../components/Reveal";

export default function Contact() {
  return (
    <main data-testid="contact-page">
      <section className="relative overflow-hidden px-5 pb-14 pt-20 text-center md:pt-28">
        <PetalField count={8} />
        <Reveal>
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#C9A227]">Find Us</p>
          <h1 className="mt-3 font-serif text-5xl font-black text-[#9B2C2C] md:text-6xl">Come Say Hello</h1>
          <div className="mt-5 flex justify-center"><Flourish className="h-4 w-56" /></div>
        </Reveal>
      </section>

      <section className="mx-auto grid max-w-7xl gap-10 px-5 pb-28 md:px-10 lg:grid-cols-5">
        <div className="flex flex-col gap-6 lg:col-span-2">
          <Reveal>
            <div className="rounded-[12px] border border-[#E8B4B8]/30 bg-white/80 p-8 shadow-[0_6px_24px_rgba(155,44,44,0.07)] backdrop-blur-sm">
              <div className="flex items-start gap-3">
                <MapPin className="mt-1 shrink-0 text-[#C9A227]" size={22} />
                <div>
                  <h2 className="font-serif text-2xl font-semibold text-[#9B2C2C]">Our Address</h2>
                  <p data-testid="contact-address" className="mt-3 text-base leading-relaxed text-[#2C2C2C]">
                    {SITE.address}
                  </p>
                  <a
                    href={SITE.mapsLink}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="contact-directions-button"
                    className="mt-5 inline-flex items-center gap-2 rounded-full border-2 border-[#C9A227] px-6 py-2.5 text-sm font-medium text-[#9B2C2C] transition-colors hover:bg-[#C9A227] hover:text-white"
                  >
                    <MapPin size={15} /> Get Directions
                  </a>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="rounded-[12px] border border-[#E8B4B8]/30 bg-white/80 p-8 shadow-[0_6px_24px_rgba(155,44,44,0.07)] backdrop-blur-sm">
              <div className="flex items-start gap-3">
                <Phone className="mt-1 shrink-0 text-[#C9A227]" size={22} />
                <div>
                  <h2 className="font-serif text-2xl font-semibold text-[#9B2C2C]">Call or WhatsApp</h2>
                  <a
                    href={SITE.phoneHref}
                    data-testid="contact-phone-link"
                    className="mt-3 block font-serif text-3xl font-bold text-[#9B2C2C] transition-colors hover:text-[#7E2222]"
                  >
                    {SITE.phone}
                  </a>
                  <div className="mt-5 flex flex-wrap gap-3">
                    <a
                      href={SITE.phoneHref}
                      data-testid="contact-call-button"
                      className="group relative rounded-full bg-[#9B2C2C] px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#7E2222]"
                    >
                      Call Now
                      <span className="absolute bottom-1.5 left-1/2 h-[2px] w-0 -translate-x-1/2 bg-[#C9A227] transition-[width] duration-300 group-hover:w-1/2" />
                    </a>
                    <a
                      href={SITE.whatsapp}
                      target="_blank"
                      rel="noreferrer"
                      data-testid="contact-whatsapp-button"
                      className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-2.5 text-sm font-medium text-white transition-transform hover:scale-105"
                    >
                      <MessageCircle size={15} /> WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.16}>
            <div className="rounded-[12px] border border-[#E8B4B8]/30 bg-white/80 p-8 shadow-[0_6px_24px_rgba(155,44,44,0.07)] backdrop-blur-sm">
              <div className="flex items-start gap-3">
                <Clock className="mt-1 shrink-0 text-[#C9A227]" size={22} />
                <div>
                  <h2 className="font-serif text-2xl font-semibold text-[#9B2C2C]">Hours</h2>
                  <p data-testid="contact-hours" className="mt-3 text-base leading-relaxed text-[#2C2C2C]">
                    Open every day<br />11:00 AM – 10:30 PM
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="lg:col-span-3">
          <div
            data-testid="contact-map"
            className="h-full min-h-[420px] overflow-hidden rounded-[12px] border-4 border-white shadow-[0_20px_60px_rgba(155,44,44,0.15)]"
          >
            <iframe
              title="Bloomora on Google Maps"
              src={SITE.mapsEmbed}
              className="h-full min-h-[420px] w-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Reveal>
      </section>
    </main>
  );
}
